module.exports = __webpack_public_path__ + "static/media/lato-v15-latin-700.874b8e7b.woff";